<div class="marketplace-orders-modal-container d-flex flex-column" style="height:564px">
    <div class="modal-header my-1">
        <h8 class="modal-title lato-bold" cvLocalizedText langSection="Command_Center" langKey="Marketplace_Orders">Marketplace Orders</h8>
        <select id="mktpModalDateSelector" *ngIf="hasSelector" class="form-control ml-auto mt-1 w-25" [(ngModel)]="selectedRange" (change)="loadData()" [attr.disabled]="disableSelector ? '' : null">
            <option id="mktpDateOpt_{{range.key}}" *ngFor="let range of possibleRanges" [value]="range.key">{{range.display}}</option>
        </select>
        <button id="closeOrdersModalBtn" [ngClass]="{ 'ml-3': hasSelector }" type="button" class="close" aria-label="Close" (click)="closeModal();">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body flex-fill pt-0">
        <cv-marketplace-orders-table [hidden]="isLoading" [orders]="orderData" [editable]="false"></cv-marketplace-orders-table>
        <div [hidden]="!isLoading">
            <cv-loader [size]="'medium'" [overlay]="true"></cv-loader>
        </div>
    </div>
</div>